import {ApiConfig} from "components/src/api/portal/ApiConfig";
import {AuthApi, PortalApi} from "components/src/api/portal/generated";
import {ChangePassword} from "components/src/auth/ChangePassword";
import {TfaSetupWizard} from "components/src/auth/TfaSetupWizard";
import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {startTransition, useState} from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import {createPortal} from "react-dom";

export const PortalAppMenu = () =>
{
    const [showChangePasswordDialog, setShowChangePasswordDialog] = useState(false);
    const [showSetup2FADialog, setShowSetup2FADialog] = useState(false);
    const [tfaRequired, setTfaRequired] = useState(false);

    const authApi = new AuthApi(ApiConfig.config());
    const portalApi = new PortalApi(ApiConfig.config());

    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    async function is2FAEnabledFunc()
    {
        // convert to matching function
        return portalApi.portalControllerGetPortalProperties().then(
            (response) => {
                setTfaRequired(response.data.tfaRequired ?? false);
                return {
                    data: response.data.tfaEnabled??false,
                    status: response.status,
                    statusText: response.statusText,
                    headers: response.headers,
                    config: response.config,
                }
            }
        )
    }

    return (
        <>
            {/* ChangePassword Modal should be placed outside this menu  */}
            {showChangePasswordDialog && createPortal(
                <ChangePassword changePasswordFunc={(param) => authApi.authControllerChangePortalPassword(param)} onClose={() => setShowChangePasswordDialog(false)}/>,
                document.body
            )}

            {/* TfaSetupWizard Modal should be placed outside this menu */}
            {showSetup2FADialog && createPortal(
                <TfaSetupWizard
                    is2FAEnabledFunc={is2FAEnabledFunc}
                    generateSecretFunc={() => authApi.authControllerGenerateTFASecret()}
                    createSecretQRCodeFunc={(secret : string) => authApi.authControllerCreate2FASecretQRCode(secret)}
                    set2FAEnabledFunc={(enabled : boolean) => authApi.authControllerSet2FAEnabled(enabled)}
                    validateOTPFunc={(otpCode : string, secret : string) => authApi.authControllerValidateTOTP({otp : otpCode, tfaSecret : secret})}
                    setSecretFunc={(secret : string) => authApi.authControllerSet2FASecret(secret)}
                    tfaRequired={tfaRequired}
                    onClose={() => setShowSetup2FADialog(false)}/>,
                document.body
            )}

            {/* startTransition is required to prevent "A component suspended while responding to synchronous input..." */}
            <NavDropdown.Item onClick={() => startTransition(() => setShowChangePasswordDialog(true))}>
                {t('common.change-password')}
            </NavDropdown.Item>
            <NavDropdown.Divider/>
            <NavDropdown.Item onClick={() => startTransition(() => setShowSetup2FADialog(true))}>
                {t('common.setup-2fa')}
            </NavDropdown.Item>
            <NavDropdown.Divider/>
        </>
    )
}
